export function fullDate(){
    const today = new Date()
    const year = today.getFullYear();
    const month = today.getMonth()+1 < 10 ? "0"+(today.getMonth()+1) : today.getMonth()+1;
    const day = today.getDate() <10 ? "0"+today.getDate() : today.getDate();
    const fullDate = year+"-"+month+"-"+day
    return fullDate
};

export  function dateMinus(dateString){
    const date = new Date(dateString);
    date.setDate(date.getDate() -1);
    return date.toISOString().split('T')[0];
};

export  function datePlus(dateString){
    const date = new Date(dateString);
    date.setDate(date.getDate() +1);
    return date.toISOString().split('T')[0];
};